import React from 'react';

interface Props {
    value: number;
}

export const Hours: React.FC<Props> = ({ value }: Props) => <>{`${value} uur`}</>;
